// extracted by mini-css-extract-plugin
module.exports = {"videoPlayerContainer":"styles_videoPlayerContainer__vJQ1W","playButton":"styles_playButton__CR1xk"};